/*eslint-disable */
import React, { useState } from "react";
import { Button, Modal, Form as FormUi, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { deleteAllOrderDispatcher } from "../../redux/actions/shipmentAction";
const ModalDiscardOrder = ({
  handleDeleteClose,
  handleDeleteSubmit,
  OpenModel,
}) => {
  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => setmodalOpen(false);

  return (
    <div>
      <Modal open={OpenModel} onClose={handleDeleteClose} size="tiny">
        <Modal.Header className="p-bold-100">{"Are you sure ?"}</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <div className="ui form">
              <p>{"You will lose all your order created."}</p>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="button"
            onClick={() => handleDeleteClose()}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {"Cancel"}
          </Button>
          <Button
            type="submit"
            onClick={() => handleDeleteSubmit()}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {"Confirm"}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteAll: () => dispatch(deleteAllOrderDispatcher()),
  };
};

export default connect(null, mapDispatchToProps)(ModalDiscardOrder);
